<script>
export let rec;
export let result;

let sankey_container;

let summary = { missingLeft: "", missingRight: "", match: "" };

if (window.google && window.google.charts) {
    google.charts.load('current', {'packages':['sankey']});
} else {
    console.warn("google charts not loaded")
}

// console.log("ReconSummary.<init>", rec, result, summary)

$:{ 
    // console.log("ReconSummary $", rec, result, summary)
    summary = result.summary;
    if (window.google && window.google.charts) {
        window.google.charts.setOnLoadCallback(()=>addCharts(summary))
    }
}

function addCharts(summary) {
  var data = new google.visualization.DataTable();
  data.addColumn('string', 'From');
  data.addColumn('string', 'To');
  data.addColumn('number', 'Weight');
  data.addRows([
    [ 'Input', 'Linked', summary.match ],
    [ 'Input', 'One-sided', summary.missingLeft + summary.missingRight ],
    [ 'One-sided', 'Missing left', summary.missingLeft ],
    [ 'One-sided', 'Missing right', summary.missingRight ],
    [ 'Linked', 'Fully matched', summary.match - summary.partial ],
    ...Object.keys(summary.rules).map(rule=>[
      "Linked", rule, summary.rules[rule]
    ]),
    [ "Fully matched", "STP", summary.match - summary.partial],
    ...Object.keys(summary.rules).map(rule=>[
      rule, "Inbox", summary.rules[rule]
    ]),
    ...Object.keys(summary.rules).map(rule=>[
      rule, "Acked", 0//summary.rules[rule]
    ]),
    ...Object.keys(summary.rules).map(rule=>[
      rule, "WontFix", 0//summary.rules[rule]
    ]),
    [ 'Missing left', "Inbox",   summary.missingLeft ],
    [ 'Missing left', "Acked",   0 ],
    [ 'Missing left', "WontFix", 0 ],
    [ 'Missing right',"Inbox",   summary.missingRight ],
    [ 'Missing right',"Acked",   0 ],
    [ 'Missing right',"WontFix", 0 ],
  ].filter(row => row[2] > 0));

  // Sets chart options.
  var options = {
    width: 600,
  };

  // Instantiates and draws our chart, passing in some options.
  var chart = new google.visualization.Sankey(sankey_container);
  chart.draw(data, options);
}

</script>


<div class="col-sm col-md ml-auto mr-auto p-4 card mt-4">
    <div class="row p-2">
      <div class="col">
        <div bind:this={sankey_container} style="width: 600px; height: 300px;"></div>
      </div>

      <div class="col">
      <table class="summary">
        <tr>
          <th colspan=2>Linked</th><td>{summary.match}</td>
        </tr>
        <tr>
          <th colspan=2>Unlinked {rec.a.name}</th><td
            >{summary.missingRight}</td
          >
        </tr>
        <tr>
          <th colspan=2>Unlinked {rec.b.name}</th><td
            >{summary.missingLeft}</td
          >
        </tr>
        <tr>
          <th colspan=2>Unmatched ({rec.config.columns.filter(c=>c.side=="a" && c.compareWithCol).length} rules)</th><td>{summary.partial}</td>
        </tr>
        {#if summary.partial}
          <tr>
            <th colspan=1>Rules:</th>
          </tr>
          {#each Object.keys(summary.rules) as x}
          <tr>
            <th style="width: 2rem;"></th>
            <th style="width: 100%;">
              <span class="rule-col">Column: {x}</span> 
              Rule: {rec.config.columns.filter(c=>c.name == x).shift().rule}
            </th>
            <td>{summary.rules[x]}</td>
          </tr>
          {/each} 
        {/if}
      </table>
      </div>
    </div>
  </div>